// Excel-compatible financial functions (same sign conventions as Excel)
export const FV = (rate, nper, pmt = 0, pv = 0, type = 0) => {
  if (rate === 0) return -(pv + pmt * nper);
  const f = Math.pow(1 + rate, nper);
  return -(pv * f + (pmt * (1 + rate * type) * (f - 1)) / rate);
};

export const PMT = (rate, nper, pv, fv = 0, type = 0) => {
  if (nper === 0) return 0;
  if (rate === 0) return -(pv + fv) / nper;
  const f = Math.pow(1 + rate, nper);
  return -(rate * (fv + pv * f)) / ((1 + rate * type) * (f - 1));
};

export const PV = (rate, nper, pmt, fv = 0, type = 0) => {
  if (rate === 0) return -(fv + pmt * nper);
  const f = Math.pow(1 + rate, nper);
  return -(fv + (pmt * (1 + rate * type) * (f - 1)) / rate) / f;
};
